import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getStorageLocalSuccess, setUserAvatarUrl, formSubmitSuccess, formSubmitFailed, FORM_SUBMIT, CALL_GET_STORAGE_LOCAL } from '../ducks/User';
import * as AvatarAPI from '../integrations/AvatarAPI';
import { message } from 'antd';
import * as UserAPI from "../integrations/UserAPI";

function* userAvatarUpload(data) {
    try {
        const { extension, token, file } = data.data;
        const imageStorageLocal = yield call(AvatarAPI.getStorageLocal, {extension, token});
        yield put(getStorageLocalSuccess(imageStorageLocal));
        yield call(AvatarAPI.uploadToS3, {file, path: imageStorageLocal});

        const signedURLResponse = yield call(AvatarAPI.getSignedURL, imageStorageLocal);
        yield put(setUserAvatarUrl(signedURLResponse.data));
    } catch(error) {
        message.error(error);
    }
}

function* userAvatarUploadSaga() {
    yield takeLatest(CALL_GET_STORAGE_LOCAL, userAvatarUpload)
}

function* userFormSubmit({data}) {
    try {
        const result = yield call(UserAPI.save, data);
        const jsonResult = JSON.parse(result);
        yield put(formSubmitSuccess(jsonResult));

    } catch(error) {
        message.error('Não foi possível cadastrar o usuário.');
        yield put(formSubmitFailed('Não foi possível cadastrar o usuário.'));
    }
}

function* userFormSubmitSaga() {
    yield takeLatest(FORM_SUBMIT, userFormSubmit)
}

export default function* rootSaga() {
    yield all([
        fork(userAvatarUploadSaga),
        fork(userFormSubmitSaga)
    ])
}



// WEBPACK FOOTER //
// ./src/sagas/userSaga.js